import { SCREEN_PATTERNS, type StudioChoice } from '@base/shared';
import { localized } from '../i18n/index.ts';
import { StudioPreview } from './Preview.tsx';
import type { PreviewView } from './PreviewBar.tsx';
import { PREVIEW_SCREENS, type PreviewScreen } from './screens/index.tsx';

/**
 * "Ver o sistema" (ADR 0133, parte 5): as 12 telas de uma vez, na escolha, para julgar o conjunto.
 * Clicar numa abre ela grande na prévia.
 */
export function SystemView({
  value,
  appName,
  brand,
  view,
  onOpen,
}: {
  value: StudioChoice;
  appName: string;
  brand?: { name: string; logo: string };
  view: PreviewView;
  onOpen: (screen: PreviewScreen) => void;
}) {
  return (
    <ul className="grid gap-4 lg:grid-cols-2 2xl:grid-cols-3">
      {PREVIEW_SCREENS.map((screen) => (
        <li key={screen}>
          <button
            type="button"
            onClick={() => onOpen(screen)}
            className="group flex w-full flex-col gap-2 text-left"
          >
            <span className="text-xs font-medium text-muted group-hover:text-ink">
              {localized(SCREEN_PATTERNS.find((p) => p.id === screen)?.name)}
            </span>
            <span className="pointer-events-none block overflow-hidden rounded-lg border border-rule group-hover:border-accent">
              <StudioPreview
                value={value}
                appName={appName}
                brand={brand}
                screen={screen}
                domain={view.domain}
                dark={view.dark}
                maxHeight={300}
              />
            </span>
          </button>
        </li>
      ))}
    </ul>
  );
}
